import React, { useState } from 'react';
import { PlusIconInsideSquare } from 'assets';
import { BasicButton } from 'components';
import { AddNewRowModal } from '../../modals';

export const AddNewRowButton = () => {
    const [isAddNewRowModalOpen, setIsAddNewRowModalOpen] = useState(false);

    const toggleAddNewRowModal = () => {
        setIsAddNewRowModalOpen(!isAddNewRowModalOpen);
    };

    return <>
        <BasicButton
            variant="outlined"
            sx={{ marginTop: '0px', marginRight: '0px', color: '#191FDB', borderColor: '#191FDB', fontWeight: '500', '&:hover': { backgroundColor: 'rgba(25, 31, 219, 0.1)', borderColor: '#141aba' } }}
            startIcon={<PlusIconInsideSquare />}
            onClick={toggleAddNewRowModal}
        >Add New Row</BasicButton>
        {isAddNewRowModalOpen && <AddNewRowModal isOpen={isAddNewRowModalOpen} onClose={toggleAddNewRowModal} />}
    </>
};
